module.exports = __webpack_public_path__ + "assets/images/project/united-states.jpg?v=00bc13ed";